import React from 'react'
import Typography from '@material-ui/core/Typography'
import { colors } from '../../../../../utils/constants'
import { LocalDate } from '../../../../../utils/date/local-date'
import { FormattedMessage, useIntl } from 'react-intl'
import PropTypes from 'prop-types';

const SemainesNonInitialisees = (datas) => {
	const intl = useIntl()

	return (
		datas && datas.semainesNonInitialisees && datas.semainesNonInitialisees.length > 0 ?
		<Typography style={{ color: colors.error }}>
			<FormattedMessage
				id="gestionTaches.ecranSynthese.error"
				values={{
					semaines: datas.semainesNonInitialisees
						.map(semaine => intl.formatMessage({ id: 'gestionTaches.ecranSynthese.errorDetail' }, { semaine: LocalDate.fromAPI(semaine).weekNumber }))
						.join(' et '),
					quantity: datas.semainesNonInitialisees.length
				}}
			/>
		</Typography> : <></>
	)
}

SemainesNonInitialisees.propTypes = {
	datas: PropTypes.shape({
		semainesNonInitialisees: PropTypes.array,
		stats: PropTypes.object,
		planificationVsCharge: PropTypes.array
	}),
}

export default SemainesNonInitialisees